import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { Container } from '../../components/Container';
import { ProfessorEditModal } from '../../components/ProfessorEditModal';
import {
  getRedirectElement,
  projetosRoute,
} from '../../library/Routes';
import { closeModal, openModal } from '../../store/modules/ModalActions';
import loginBackground from './../../assets/images/login-background.jpg';
import styles from './AutoCadastro.scss';
import LoaderGlobal from 'components/Loader/LoaderApp/LoaderGlobal';
import { isAuthenticated } from 'services/Auth/AuthService';

const rootClassName = styles.rootClassName;

const AutoCadastro = () => {
  const [modalKey, setModalKey] = useState(null);
  const [authStatus, setAuthStatus] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const toBackToLogin = async () => {
    if (modalKey) {
      dispatch(closeModal(modalKey));
      setModalKey(null);
    }
    history.push('/');
  };

  useEffect(() => {
    const checkAuthAndOpenModal = async () => {
      const authenticated = await isAuthenticated();
      setAuthStatus(authenticated);

      if (!authenticated) {
        const currModal = dispatch(openModal(ProfessorEditModal, {
          isAutoRegister: true,
          cancelCallback: toBackToLogin,
          savedCallback: toBackToLogin,
        }));
        setModalKey(currModal.payload.key);
      }
    };

    checkAuthAndOpenModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  if (authStatus === null) {
    return <LoaderGlobal />;
  }

  return authStatus ? (
    getRedirectElement(projetosRoute.path)
  ) : (
    <Container
      className={`${rootClassName}-container`}
      style={{ backgroundImage: `url(${loginBackground})` }}
    />
  );
};

export default withRouter(AutoCadastro);
